import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-hero-slides',
  templateUrl: './hero-slides-form-field.component.html',
  standalone: false,
})
export class HeroSlidesFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  constructor() {
    super();
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnInit() {}

  ngOnDestroy() {}
}
